'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isUnauthorizedUserError = function isUnauthorizedUserError(error) {
  var errorName = error.name,
    text = error.text;
  return text === 'Unauthorized User' || errorName === 'SASLError';
};
exports.isUnauthorizedUserError = isUnauthorizedUserError;